import {
    FETCH_GDPR_GRANT_CONSENT,
    FETCH_GDPR_GRANT_CONSENT_SUCCESS,
    FETCH_GDPR_GRANT_CONSENT_FAIL,
    RESET_GDPR_GRANT_CONSENT
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    grantConsent: {},
    grantConsentState: true
};

const fetchGdprGrantConsentSuccess = (isSuccess) => (state, action) => {
    return {
        isFetching: false,
        grantConsent: { ...state.grantConsent, [action.key]: action.grantConsent },
        grantConsentState: isSuccess
    };
};

const resetGdprGrantConsent = () => {
    return { ...INITIAL_STATE };
};

const handlers = {
    [FETCH_GDPR_GRANT_CONSENT_SUCCESS]: fetchGdprGrantConsentSuccess(true),
    [FETCH_GDPR_GRANT_CONSENT_FAIL]: fetchGdprGrantConsentSuccess(false),
    [RESET_GDPR_GRANT_CONSENT]: resetGdprGrantConsent
};

export default function GdprGrantConsent(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchGdprGrantConsent(key, locale, consentVersion, featureKey) {
    return {
        type: FETCH_GDPR_GRANT_CONSENT,
        key,
        locale,
        consentVersion,
        featureKey,
        isFetching: true
    };
}

export const getGdprGrantConsent = (state, key) => {
    return state.gdprGrantConsent.grantConsent[key];
};

export const getGdprGrantConsentState = (state) => {
    return state.gdprGrantConsent.grantConsentState;
};
